export const initialState = {
  location: null,
  isAuthCheckComplete: false,
  isEcommercePage: false,
  isAccountConfirmed: false,
  isAccountConfirmationRequired: false,
  isAccountChangeRequested: false,
  locale: undefined,
  isCartInitialized: false,
  cart: undefined,
  accountId: undefined,
  activeAccount: null,
  accounts: undefined,
  isAccountsLoading: undefined,
  currency: undefined,
  countryCode: null,
  globalEcommerceLabels: null,
  productDetailLabels: null,
  skuCountryExclusions: null,
}

export interface EcomState {
  location: string | null
  isAuthCheckComplete: boolean
  isEcommercePage: boolean
  isAccountConfirmed: boolean
  isAccountConfirmationRequired: boolean
  isAccountChangeRequested: boolean
  locale: string | undefined
  isCartInitialized: boolean
  cart: any
  accountId?: string
  activeAccount: any | null
  accounts?: any
  isAccountsLoading?: boolean
  currency?: string
  countryCode: string | null
  globalEcommerceLabels: any
  productDetailLabels: any
  skuCountryExclusions: Record<string, string[]> | null
}

export type EcomAction =
  | { type: "SET_AUTH_CHECK_COMPLETE"; payload: boolean }
  | { type: "SET_LOCATION"; payload: string | null }
  | { type: "ONE_TRUST_INITIALIZED" }
  | { type: "SET_LOCALE"; payload: { locale: string } }
  | { type: "SET_CART_INITIALIZED"; payload: boolean }
  | { type: "UPDATE_CART"; payload: any }
  | { type: "SET_ACCOUNTS_LOADING"; payload: boolean }
  | { type: "SET_ACCOUNTS"; payload: any }
  | { type: "PATCH_ACCOUNTS"; payload: any }
  | { type: "SET_ACCOUNT_ID"; payload: string }
  | { type: "SET_ACTIVE_ACCOUNT"; payload: any }
  | { type: "SET_ACCOUNT_CONFIRMED"; payload: boolean }
  | { type: "SET_ACCOUNT_CONFIRMATION_REQUIRED"; payload: boolean }
  | { type: "SET_ACCOUNT_CHANGE_REQUESTED"; payload: boolean }
  | { type: "SET_ECOMMERCE_PAGE"; payload: boolean }
  | { type: "SET_CURRENCY"; payload: string }
  | { type: "SET_COUNTRY"; payload: string }
  | { type: "SET_GLOBAL_ECOMMERCE_LABELS"; payload: any }
  | { type: "SET_PRODUCT_DETAIL_LABELS"; payload: any }
  | { type: "SET_SKU_COUNTRY_EXCLUSIONS"; payload: Record<string, string[]> }
  | { type: string; payload?: any }

export const ecomReducer = (
  state: EcomState = initialState,
  action: EcomAction,
): EcomState => {
  switch (action.type) {
    case "SET_AUTH_CHECK_COMPLETE":
      return {
        ...state,
        isAuthCheckComplete: action.payload,
      }
    case "SET_LOCATION":
      return {
        ...state,
        location: action.payload,
      }
    case "SET_LOCALE":
      return {
        ...state,
        locale: action.payload.locale,
      }
    case "SET_CART_INITIALIZED":
      return {
        ...state,
        isCartInitialized: action.payload,
      }
    case "UPDATE_CART":
      return {
        ...state,
        cart: action.payload,
      }
    case "SET_ACCOUNTS_LOADING":
      return {
        ...state,
        isAccountsLoading: action.payload,
      }
    case "SET_ACCOUNTS":
      return {
        ...state,
        accounts: action.payload,
      }
    case "PATCH_ACCOUNTS": {
      const newAccounts = state?.accounts?.map((account: any) => {
        if (action.payload.id === account.id) {
          return action.payload
        }
        return account
      })
      return {
        ...state,
        accounts: newAccounts,
      }
    }
    case "SET_ACCOUNT_ID":
      return {
        ...state,
        accountId: action.payload,
      }
    case "SET_ACTIVE_ACCOUNT":
      return {
        ...state,
        activeAccount: action.payload,
      }
    case "SET_ACCOUNT_CONFIRMED":
      return {
        ...state,
        isAccountConfirmed: action.payload,
      }
    case "SET_ACCOUNT_CONFIRMATION_REQUIRED":
      return {
        ...state,
        isAccountConfirmationRequired: action.payload,
      }
    case "SET_ACCOUNT_CHANGE_REQUESTED":
      return {
        ...state,
        isAccountChangeRequested: action.payload,
      }
    case "SET_ECOMMERCE_PAGE":
      return {
        ...state,
        isEcommercePage: action.payload,
      }
    case "SET_CURRENCY":
      return {
        ...state,
        currency: action.payload,
      }
    case "SET_COUNTRY":
      return {
        ...state,
        countryCode: action.payload,
      }
    case "SET_GLOBAL_ECOMMERCE_LABELS":
      return {
        ...state,
        globalEcommerceLabels: action.payload,
      }
    case "SET_PRODUCT_DETAIL_LABELS":
      return {
        ...state,
        productDetailLabels: action.payload,
      }
    case "SET_SKU_COUNTRY_EXCLUSIONS":
      return {
        ...state,
        skuCountryExclusions: action.payload,
      }
    default:
      return state
  }
}
